module.exports = __webpack_public_path__ + "img/app/home/img/icon-down.274b95c353fd35430034661315370419.png";